import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { FuseLoadingService } from '@fuse/services/loading/loading.service';

const IGNORE_LOADER_URLS = ['/api/ping'];

@Injectable()
export class FuseLoadingInterceptor implements HttpInterceptor {
    handleRequestsAutomatically: boolean;

    /**
     * Constructor
     */
    constructor(private _fuseLoadingService: FuseLoadingService) {
        // Subscribe to the auto
        this._fuseLoadingService.auto$.subscribe((value) => {
            this.handleRequestsAutomatically = value;
        });
    }

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const shouldIgnore = this.shouldIgnore(req.url);

        if (!this.handleRequestsAutomatically || shouldIgnore) {
            return next.handle(req); // skip loader completely
        }

        this._fuseLoadingService._setLoadingStatus(true, req.url);

        return next.handle(req).pipe(
            finalize(() => {
                this._fuseLoadingService._setLoadingStatus(false, req.url);
            })
        );
    }

    private shouldIgnore(url: string): boolean {
        //Add here the list of BE calls that need to be ignored by the loaders
        const IGNORED_URLS = ['/avis-be/orders/summary'];
        return IGNORED_URLS.some((ignored) => url.includes(ignored));
    }
}
